module.exports = __webpack_public_path__ + "img/Dantam Makeover 02.6c6e4f01.jpg";